import moment from 'moment';
import http from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        // sort,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        // ...sort,
        dateFrom: filters.dateFrom ? moment.utc(filters.dateFrom).unix() : undefined,
        dateTo: filters.dateTo ? moment.utc(filters.dateTo).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        // getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('v1/p2p/offers', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async editOffer(__store, data) {
      const response = await http.put(`v1/p2p/offers/${data.offerId}`, data);
      if (!response?.data?.result?.Success) {
        throw new Error(`The offer has not been edited because of Error: "${response?.data?.result?.Error}"`);
      }
      return response.data;
    },

    async enableAll() {
      await http.post('v1/p2p/offers/enable-stopped-offers', {});
    },

    async stopAll() {
      await http.post('v1/p2p/offers/stop-enabled-offers', {});
    },
  },

  namespaced: true,
});
